import React from 'react'

export default function About() {
    return (
        <div>
                 <h2>About Page</h2>
        </div>
    )
}
